import React from 'react';
import Modal from 'react-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  content: string;
  onCloseText: string;
  onSuccessText?: string;
  onCancel: () => void;
  onSuccess?: any;
}

const AlertModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onCancel,
  title,
  content,
  onCloseText,
  onSuccessText,
  onSuccess,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="modal-content alert"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="alertModalWrap">
          <div className="header">
            <img src={`${process.env.PUBLIC_URL}/svg/warning.svg`} alt="경고" />
            <h2>{title}</h2>
            <button onClick={onCancel}>
              <img
                className="closeBtn"
                src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                alt="닫기"
              />
            </button>
          </div>
          <p>{content}</p>
          <div className="buttonWrap">
            {onSuccessText && (
              <button onClick={onSuccess} className="successButton">
                {onSuccessText}
              </button>
            )}
            <button onClick={onCancel} className="closeButton">
              {onCloseText}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default AlertModal;
const Style = styled.div`
  h2 {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #555555;
    text-align: center;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    white-space: pre-line;
    text-align: center;
    line-height: 28px;
    color: #979797;
  }
  .alertModalWrap {
    width: 100%;
    padding: 10px 20px 30px 20px;
    border-radius: 50px;
  }

  .header {
    position: relative;
    padding-top: 30px;
    text-align: center;

    .closeBtn {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .buttonWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    padding: 0;

    button {
      padding: 14px 0;
      flex: 1;
      border-radius: 8px;
    }
  }
  .successButton {
    background: #4dd2ae;
    color: #fff;
  }
  .closeButton {
    background: #FF6060;
    color: #fff;
    font-weight: 500;
  }
  @media (max-width: 1200px) {
    .alertModalWrap {
      padding: 10px 10px 20px 10px;
    }
    button {
      font-size: 16px;
    }

    h2 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
